export const pushEvent = (
  eventName: string,
  params: Record<string, any> = {},
) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
  }
};

declare global {
  interface Window {
    dataLayer: any[];
  }
}
